import produce from "immer";
import { CustomizationState } from "../../";

export interface SetEventQueueAction {
  way: "use" | "add";
  event?: () => void;
  type: "setEventQueue";
}

export function setEventQueue(
  state: CustomizationState,
  action: SetEventQueueAction
): CustomizationState {
  return produce(state, (draftState) => {
    if (action.way === "add" && action.event) {
      if (!draftState.ui.eventQueue) {
        draftState.ui.eventQueue = [];
      }
      draftState.ui.eventQueue.push(action.event);
    } else if (draftState.ui.eventQueue) {
      const eventToTrigger = draftState.ui.eventQueue.shift();
      if (eventToTrigger) {
        eventToTrigger();
      }
    }
  });
}
